// extracted by mini-css-extract-plugin
export default {"list":"in_cZ0ActBUmM3zqslpa","responsive":"MubmpSc8ZXc1N9NZCDsC"};